export default {
      id: "upload_small_black-usage",
      viewBox: "0 0 18 21",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#upload_small_black",
      toString: function () {
        return this.url;
      }
    }